module.exports = __webpack_public_path__ + "static/media/break.50428e3d.svg";